import { Pipe, PipeTransform } from "@angular/core";

export function formatDocument(value: string | null | undefined): string {
    if (!value) return "";

    const cleaned = String(value)
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase()
        .slice(0, 14);

    if (cleaned.length <= 11) {
        return cleaned
            .replace(/^([0-9]{3})([0-9])/, "$1.$2")
            .replace(/^([0-9]{3})\.([0-9]{3})([0-9])/, "$1.$2.$3")
            .replace(/^([0-9]{3})\.([0-9]{3})\.([0-9]{3})([0-9])/, "$1.$2.$3-$4");
    }

    return cleaned
        .replace(/^([A-Z0-9]{2})([A-Z0-9])/, "$1.$2")
        .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3")
        .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3/$4")
        .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})([A-Z0-9])/, "$1.$2.$3/$4-$5");
}

@Pipe({ name: "documentFormat" })
export class DocumentFormatPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return formatDocument(value);
    }
}
